import React, { useEffect,useRef,useState } from "react";
import classes from "./HorizontalScroll.module.css"
const HorizontalScroll  = props=>{
const menu_wrapper = useRef(null);
const itemList = useRef(null);
const item = useRef(null);
const leftPaddle = useRef(null);
const rightPaddle = useRef(null);


    useEffect(()=>{
       
        try{
 
             // get items dimensions
            // window.itemsLength = workouts.length;
            window.itemsLength = 20000;
            window.itemSize = item.current.offsetWidth;
            // window.itemSize = 240
            window.menuWrapperSize = getMenuWrapperSize();
            // the wrapper is responsive
            window.addEventListener('resize', function(event){
                // do stuff here
                try{
                    window.menuWrapperSize = getMenuWrapperSize();
                }catch(error){
                    
                }
            
            });
            // size of the visible part of the menu is equal as the wrapper size 
            window.menuVisibleSize = window.menuWrapperSize;
            window.menuSize = getMenuSize();
            //  console.log(window.menuWrapperSize,window.menuSize)
            // get how much of menu is invisible
            window.menuInvisibleSize = window.menuSize - window.menuWrapperSize;

            document.getElementById('itemList'+props.index).addEventListener('scroll',()=>{
                onListScroll()
            })
            leftPaddle.current.style.display="none";


        }catch(error){
            return null
        }

    },[])
    
    //duration of scroll animation
var scrollDuration = 300;

// get some relevant size for the paddle triggering point
var paddleMargin = 20;

// get wrapper width
var getMenuWrapperSize = function() {
	return menu_wrapper.current.offsetWidth;
}

// get total width of all menu items
var getMenuSize = function() {
	return window.itemsLength * window.itemSize;
};


// get how much have we scrolled to the left
var getMenuPosition = function() {
	return itemList.current.scrollLeft;
};


// finally, what happens when we are actually scrolling the menu

const onListScroll = ()=>{
    	// get how much of menu is invisible
	let menuInvisibleSize = window.menuSize - window.menuWrapperSize;
	// get how much have we scrolled so far
	var menuPosition = getMenuPosition();

	var menuEndOffset = menuInvisibleSize - paddleMargin;
        // console.log(menuPosition,menuEndOffset)
	// show & hide the paddles 
	// depending on scroll position
	if (menuPosition <= paddleMargin) {
        // alert("1")
        leftPaddle.current.style.display="none";
        rightPaddle.current.style.display="block";
	}  else if (menuPosition >= menuEndOffset) {
        // alert("3")
		leftPaddle.current.style.display="block";
		rightPaddle.current.style.display="none";
}else if (menuPosition < menuEndOffset) {
    // alert("2")
    // show both paddles in the middle
    leftPaddle.current.style.display="block";
    rightPaddle.current.style.display="block";
}
 
}

var workouts = props.workouts;
    

    if(!workouts){
        return null
    }
    if(workouts.length<1){
        return null
    }


const onRightPaddleClick = (id)=>{
    
    document.getElementById("itemList"+props.index).scrollBy({ left: window.menuInvisibleSize, top: 0, behavior: 'smooth' });
//    console.log(item)
}

const onLeftPaddleClick = (id)=>{
    document.getElementById("itemList"+props.index).scrollBy({ left: -window.menuInvisibleSize, top: 0, behavior: 'smooth' });
}
console.clear() 
    return (
    <>
        <div className={classes.MENUWRAPPER} ref={menu_wrapper}>
            <ul className={classes.MENU} ref={itemList} id={"itemList"+props.index}>
                {
                    workouts.map(workout=>(
                        <li className={`${classes.ITEM} testitem`} key={workout.id} ref={item} >
                            <div>
                            <iframe height="80%"
                                width="100%" 
                                src={workout.url} 
                                title="YouTube video player" 
                                frameBorder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                allowFullScreen="allowfullscreen"
                                mozallowfullscreen="mozallowfullscreen" 
                                msallowfullscreen="msallowfullscreen" 
                                oallowfullscreen="oallowfullscreen" 
                                webkitallowfullscreen="webkitallowfullscreen"
                                >
                               
                                </iframe>
                                <div style={{height:"40px",overflow:"clip"}}>
                                        <p><h6 >{workout.title} </h6></p>
                                    </div>
                                </div>
                            
                        </li>
                    ))
                }
               
              
               
            </ul>
     
        <div className={classes.PADDLES}>
        
            <button className={`${classes.LEFTPADDLE} ${classes.PADDLE}`} ref={leftPaddle} onClick={()=>onLeftPaddleClick("itemList"+props.index)}>
                <i className="fa fa-chevron-circle-left" aria-hidden="true"></i>
            </button>
            <button className={`${classes.RIGHTPADDLE} ${classes.PADDLE}`} onClick={()=>onRightPaddleClick("itemList"+props.index)} ref={rightPaddle}>
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
            </button>
        </div>
    
    </div>
    
    
</>

    )
}
export default HorizontalScroll;


// <li className={classes.ITEM} key={workout.id} ref={item} >
                
// <iframe height="100%"
//     width="100%" 
//     src={workout.url} 
//     title="YouTube video player" 
//     frameBorder="0" 
//     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
//     allowFullScreen="allowfullscreen"
//     mozallowfullscreen="mozallowfullscreen" 
//     msallowfullscreen="msallowfullscreen" 
//     oallowfullscreen="oallowfullscreen" 
//     webkitallowfullscreen="webkitallowfullscreen"
//     >
        
//     </iframe>

// </li>